<template>
    <dl class="search__dropdown-groups">
        <dt>
            {{ group.name }} ({{ paginator.total }})
        </dt>

        <dd>
            <list-item v-for="item in items" :item="item" :key="item.id"></list-item>

            <a href="#" v-if="showMore" class="search__dropdown-item font-italic" @click.prevent="loadMore">
                <i class="gbi-arrow-right-double small color-green"></i>
                Подгрузить ещё {{ numForLoad }} из {{ paginator.total - items.length }}
            </a>
        </dd>
    </dl>
</template>

<script>
    export default {
        props: {
            group: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                items: this.group.items,
                paginator: this.group.paginator
            }
        },

        methods: {
            loadMore() {
                this.$parent.fetchItems(this.getRoute()).then(response => {
                    this.items.push(...response.items)
                    this.paginator = response.paginator

                    this.$emit('group-replenished', response.items.length, ! this.showMore)
                })
            },

            getRoute() {
                return this.paginator.path.replace('/' + this.group.alias, '')
                    + `/${this.group.alias}?`
                    + this.paginator.next_page_url.split('?')[1]
            }
        },

        computed: {
            numForLoad() {
                let remaining = this.paginator.total - this.items.length

                return remaining > this.paginator.per_page ? this.paginator.per_page : remaining
            },

            showMore() {
                return this.paginator.next_page_url
            }
        },

        components: {
            ListItem: require('./list-item').default
        }
    }
</script>